import React, { useEffect, useState } from "react"
import styled from "styled-components"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

//Parts
import LogoImage from "./header/LogoImage"
import Navigation from "./header/navigation/Navigation"

//Responsive
import { device } from "../utils/breakpoints"
import { anims, colors } from "../utils/theme"

const HeaderBar = styled.header`
  position: absolute;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  padding: 1rem 0;
  ${anims.transition};
  &.active {
    background: transparent;
    @media ${device.md} {
      background-color: ${colors.pColor};
      padding: 2rem 0;
    }
    & .asesory {
      color: ${colors.pColor} !important;
    }
  }
  & .col-nav {
    display: none;
    @media ${device.md} {
      display: block;
      padding: 0.7rem auto;
    }
  }
`

const Header = ({ siteTitle }) => {
  const [headerScrolled, setHeaderScrolled] = useState(false)
  const handleScroll = e => {
    window.scrollY > 100 ? setHeaderScrolled(true) : setHeaderScrolled(false)
  }
  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
  }, [])
  return (
    <HeaderBar className={headerScrolled ? "active" : ""}>
      <Container>
        <Row className="align-items-center">
          <Col md={3} className="col-logo">
            {" "}
            <LogoImage />{" "}
          </Col>
          {/* <Col md={9} className="col-nav text-right">
            {" "}
            <Navigation />{" "}
          </Col> */}
        </Row>
      </Container>
    </HeaderBar>
  )
}

export default Header
